export const categories = [
  "Tablets",
  "Sanitary Pads",
  "Adult Diapers",
  "Soaps",
  "Wet Wipes"
].map((name) => ({
  name,
  id: name.toLowerCase().replace(/\s+/g, "-"),
}));
